class ColumnFactory {
  getName() {
    return 'comprobante-columns';
  }

  apply(data, order) {
    if (order.length === 0) {
      return data;
    }

    let columns = [];

    for (const element of order) {
      for (const item of data) {
        if (item.key === element) {
          columns.push({ ...item });
          break;
        }
      }
    }

    return columns;
  }
}

export default ColumnFactory;
